export default __webpack_public_path__ + "static/media/prestamoCelular.a1ca1edd.png";